import { SegmentedControl, Select } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Lock } from '../icons'
import IsMultiSelect from './is_multi_select'

const SelectCollection = ({ schema, field, saveField }) => {
  const [collectionID, setCollectionID] = useState(field.collection_id)
  const [showCollections, setShowCollections] = useState(!field.use_languages)
  const { data: collections, isLoading } = useQuery([`collections?schemaID=${schema.id}`])
  const options = collections ? collections.map((collection) => ({ value: collection.id, label: collection.name })) : []
  const isLocked = field?.uneditable_when_locked_attributes?.includes('use_languages') ?? false
  const updateField = (collectionID) => {
    setCollectionID(collectionID)

    if (collectionID) {
      saveField({ collection_id: collectionID, use_languages: false })
    } else {
      saveField({ collection_id: null, use_languages: true })
    }
  }
  return (
    <div className='space-y-4'>
      <SegmentedControl
        label={{
          text: 'List type',
          icon: { icon: isLocked ? Lock : '' },
        }}
        options={[
          { label: 'Custom List', value: 'list' },
          { label: 'Language List', value: 'language' },
        ]}
        disabled={isLocked}
        value={!showCollections ? 'language' : 'list'}
        onChange={(opt) => {
          if (opt === 'language') {
            updateField(null)
            setShowCollections(false)
          } else {
            setShowCollections(true)
          }
        }}
      />
      {showCollections && (
        <Select
          label='List'
          isLoading={isLoading}
          options={options}
          disabled={isLocked}
          topIcon={isLocked ? Lock : ''}
          value={options.find((opt) => opt.value === collectionID)}
          onChange={(opt) => updateField(opt.value)}
        />
      )}
      <IsMultiSelect field={field} saveField={saveField} />
    </div>
  )
}

export default SelectCollection
